<script setup>
import {nextTick, onBeforeMount, reactive, ref} from "vue";
import router from "@/router/index.js";
import createTenant from "./components/createTenant/index.vue"
import moment from "moment/moment.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {ElMessage} from "element-plus";
import YTFormDialog from "@/components/YTFormDialog/index.vue";
import {getRoute} from "@/hooks/getRoute.js";
import {detailTenant, editTenant, listMenuAll, listRole} from "@/api/user/user.js";
import {listTenantOrganizeIgnore, listTenantOrganizeNotStoreIdIgnore} from "@/api/tenant/tenant.js";
import {
  addAdminIgnore,
  deleteAdminIgnore, detailAdminIgnore,
  listAdminIgnore,
  unBindAdminIgnore,
  updateAdminIgnore
} from "@/api/admin/ignoreTenant.js";
import {getStoreCooperation, uploadStoreCooperation} from "@/api/storeCooperation/storeCooperation.js";
import YTPartnerSelectPanel from "@/views/tenant/components/YTPartnerSelectPanel/index.vue";
import {getOrganizeIgnore, updateOrganizePermissionIgnore} from "@/api/organize/ignoreTenant.js";

/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.tenantId)
  if (isEdit.value) {
    await getDetail()
  } else {
    ElMessage.error("信息获取失败")
    loading.value = true
  }
})

/*标签页相关*/
// 当前标签页
const currentTab = ref("1")
// 处理标签页改变
const handleTabChange = (e) => {
  if (currentTab.value === "1") {
    getDetail()
  } else if (currentTab.value === "2") {
    handleSearch("init")
  } else if (currentTab.value === "3") {
    handleSearchAccount("init")
  }
}
// 处理新增合作身份
const handleAddCooperative = () => {
  openCooperative.value = true
}

/*基本信息相关*/
// 商家信息
const tenantInfo = ref({
  // 商家id
  tenantId: null,
  // 商家信息
  name: null,
  // 认证类型
  certificationType: "LEGAL_PERSON",
  // 证件信息
  certificateInfo: {
    certificateId: null,
    certificateFrontPhoto: null,
    certificateBackPhoto: null,
  },
  //  进驻类型
  entryType: null,
  // 负责人信息
  contactInfo: {
    contactName: null,
    contactPhone: null,
    contactEmail: null
  },
  // 收款账号信息
  payeeAccountInfo: {
    accountName: null,
    bankAccount: null,
    bankName: null
  },
  // 收件人信息
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  }
})
// 获取商家信息
const getDetail = async () => {
  try {
    loading.value = true
    const res = await detailTenant(route.query.tenantId)
    console.log("res", res)
    tenantInfo.value = res
    let temp = [tenantInfo.value.recipientInfo.recipientAddress.province, tenantInfo.value.recipientInfo.recipientAddress.city]
    if (tenantInfo.value.recipientInfo.recipientAddress.district) temp.push(tenantInfo.value.recipientInfo.recipientAddress.district)
    createTenantRef.value.handleReviewAddressCode(temp)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 商家信息组件锚点
const createTenantRef = ref()
// 处理表单提交新建商家
const handleCreateTenant = async (form) => {
  try {
    loading.value = true
    await editTenant(tenantInfo.value)
    ElMessage.success("修改成功")
    router.push({ path: "/listTenant" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*合作身份表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '名称', key: 'name', nowrap: true },
  { title: '合作身份', key: 'type', nowrap: true },
  { title: '所在地区', key: 'storeAddress', nowrap: true },
  { title: '负责人', key: 'contactName', nowrap: true },
  { title: '联系电话', key: 'phone', nowrap: true },
  { title: '进驻时间', key: 'crTime', nowrap: true },
  { title: '关联状态', key: 'bikeStoreId', nowrap: true },
  { title: '操作', key: 'controls', width: "120px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*账号管理表格数据展示*/
// 翻页组件锚点
const YTTablePaginationAccountRef = ref()
// 翻页信息：总条目数、加载状态
const totalAccount = ref(0)
const loadingAccount = ref(false)
const headersAccount = ref([
  { title: '用户名', key: 'nickname', nowrap: true },
  { title: '账号', key: 'phone', nowrap: true },
  { title: '所属合作身份', key: 'adminStoreList.storeName', nowrap: true },
  { title: '权限角色', key: 'adminStoreList.roleName', nowrap: true },
  { title: '微信绑定', key: 'bindWechat', nowrap: true },
  { title: '创建日期', key: 'crTime', nowrap: true },
  { title: '最近登录时间', key: 'lastLogin', nowrap: true },
  { title: '操作', key: 'controls', width: "120px", fixed: true },
])
// 表格数据
const tableDataAccount = ref([])
// 翻页
const handleChangeAccountPage = () => {
  handleSearchAccount()
}
// 新建管理账号
const handleAddAccount = () => {
  openAccount.value = true
  dialogAccountForm.tenantId = tenantInfo.value.tenantId
}

/*合作身份tag相关*/
// 搜索合作身份信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      tenantId: tenantInfo.value.tenantId,
    }
    const res = await listTenantOrganizeIgnore(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 查看合作身份详情
const handleGetDetail = (item) => {
  if (item.type === 1) {
    router.push({path: "/editTenantPost", query: {storeId: item.storeId}})
  } else if (item.type === 3) {
    router.push({path: "/editTenantClub", query: {storeId: item.storeId}})
  } else if (item.type === 4) {
    router.push({path: "/editTenantVenue", query: {storeId: item.storeId}})
  } else if (item.type === 5) {
    router.push({path: "/editTenantBikeStore", query: {storeId: item.storeId}})
  } else if (item.type === 6) {
    router.push({path: "/editTenantTherapy", query: {storeId: item.storeId}})
  } else if (item.type === 7) {
    router.push({path: "/editTenantPhotography", query: {storeId: item.storeId}})
  } else if (item.type === 8) {
    router.push({path: "/editTenantBrand", query: {storeId: item.storeId}})
  }
}

// 账号管理表单数据
const formDataAccount = reactive({

});
// 根据表单搜索账号管理信息
const handleSearchAccount = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationAccountRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationAccountRef.value.getPage(),
      pageSize: YTTablePaginationAccountRef.value.getPageSize()
    }
    loadingAccount.value = true
    let param = {
      tenantId: tenantInfo.value.tenantId,
    }
    const res = await listAdminIgnore(page, param);
    tableDataAccount.value = [{}]
    tableDataAccount.value = res.list
    totalAccount.value = parseInt(res.total)
    loadingAccount.value = false
  } catch (e) {
    console.log(e)
    loadingAccount.value = false
  }
}

/*操作栏相关*/
// 处理关联合作身份
const handleCorrelation = async (item) => {
  cacheTenantId.value = item.tenantId
  cacheStoreId.value = item.storeId
  try {
    cachePartnerStores.value = await getStoreCooperation(cacheStoreId.value)
    handleOpenPanel()
  } catch (e) {
    console.log(e)
  }
}
// 处理删除管理账号
const handleRemove = async (item) => {
  try {
    loading.value = true
    await deleteAdminIgnore(item.adminId)
    ElMessage.success("删除成功")
    handleSearchAccount()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理编辑管理账号
const handleEditAccount = async (item) => {
  openAccount.value = true
  console.log("item", item)
  try {
    dialogAccountLoading.value = true
    const res = await detailAdminIgnore(item.adminId)
    dialogAccountForm.adminId = res.adminId
    dialogAccountForm.nickname = res.nickname
    dialogAccountForm.username = res.username
    dialogAccountForm.adminStoreList = res.adminStoreList
    dialogAccountLoading.value = false
  } catch (e) {
    console.log(e)
    dialogAccountLoading.value = false
  }

  accountIsEdit.value = true
}
// 处理微信绑定
const handleBindWeChat = (item) => {
  handleOpenQrCode(item)
}
// 处理微信解绑
const handleUnBindWeChat = async (item) => {
  try {
    loading.value = true
    await unBindAdminIgnore(item.adminId)
    ElMessage.success("解绑成功")
    handleSearchAccount()
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*绑定微信弹窗相关*/
// 弹窗状态
const openQR = ref(false)
// 缓存查看的二维码地址
const showQrCodeUrl = ref(null)
// 请求基地址
const url = import.meta.env.VITE_APP_ENV === "development" ? "https://dev.yttec.net/api" : import.meta.env.VITE_API_URL
const appid = import.meta.env.VITE_APP_ENV === "development" ? "wx9117abc687d73792" : import.meta.env.VITE_WECHAT_APPID
// 处理打开二维码动作
const handleOpenQrCode = (user) => {
  openQR.value = true
  nextTick(() => {
    new WxLogin({
      self_redirect: true,
      id: `qrCodeDialog`,
      appid: appid,
      scope: "snsapi_login",
      redirect_uri: `${url}/admin/callback/creationAdminQrCallback/${user.adminId}`,
      fast_login: 0,
      stylelite: 1
    });
  })
}
// 关闭对话框
const closeQRDialog = () => {
  openQR.value = false
  clearQRDialog()
}
// 清除对话框表单校验
const clearQRDialog = () => {
  showQrCodeUrl.value = null
}
// 关闭二维码对话框
const closeQrCodeDialog = async () => {
  openQR.value = false
  handleSearchAccount()
}

/*管理账号弹窗相关*/
// 弹窗是否编辑状态
const accountIsEdit = ref(false)
// 弹窗状态
const openAccount = ref(false)
// 弹窗表单锚点
const dialogFormAccountRef = ref()
// 弹窗表单
const dialogAccountForm = reactive({
  adminId: null,
  nickname: null,
  username: null,
  tenantId: null,
  adminStoreList: [
    {
      storeName: null,
      storeId: null
    }
  ]
})
// 校验合作身份规则
const checkAdminRole = (rule, value, callback) => {
  for(let i = 0; i < dialogAccountForm.adminStoreList.length; i++) {
    if(!dialogAccountForm.adminStoreList[i].storeId) {
      return callback(new Error(`请选择第${i + 1}个合作身份`))
    }
  }
  return callback()
}
// 弹窗表单校验规则
const dialogAccountRules = {
  nickname: [
    {required: true, message: '请输入用户名', trigger: 'blur'}
  ],
  username: [
    {required: true, message: '请输入账号', trigger: 'blur'}
  ],
  adminStoreList: [
    {required: true, validator: checkAdminRole, trigger: 'blur'}
  ]
}
// 弹窗加载状态
const dialogAccountLoading = ref(false)
// 处理弹窗关闭
const closeAccountDialog = () => {
  dialogAccountForm.adminId = null
  dialogAccountForm.nickname = null
  dialogAccountForm.username = null
  dialogAccountForm.adminStoreList = [
    {
      storeName: null,
      storeId: null,
    }
  ]
  openAccount.value = false
  accountIsEdit.value = false
}
// 处理表单提交
const submitAccountDialog = () => {
  dialogFormAccountRef.value.validate(async (valid) => {
    if (valid) {
      dialogAccountLoading.value = true
      if (accountIsEdit.value) {
        await updateAdminIgnore(dialogAccountForm)
      } else {
        await addAdminIgnore(dialogAccountForm)
      }
      ElMessage.success(accountIsEdit.value ? "编辑成功" : "添加成功")
      closeAccountDialog()
      handleSearchAccount("init")
      dialogAccountLoading.value = false
    } else {
      ElMessage.error("请根据提示修改表单信息")
      dialogAccountLoading.value = false
    }
  })
}
// 添加合作身份
const addCooperative = () => {
  if (dialogAccountForm.adminStoreList.length >= 6) return ElMessage.error("最多只允许添加6个合作身份")
  dialogAccountForm.adminStoreList.push({
    storeName: null,
    storeId: null,
  })
}
// 删除合作身份
const handleRemoveCooperative = (index) => {
  dialogAccountForm.adminStoreList.splice(index, 1)
}

/*合作身份编辑权限相关*/
// 合作身份编辑权限弹窗状态
const openRolePermissions = ref(false)
// 合作身份编辑权限表单锚点
const rolePermissionsRef = ref()
// 合作身份编辑权限加载状态
const rolePermissionsLoading = ref(false)
// 合作身份编辑权限表单
const rolePermissionsForm = reactive({
  type: null,
  name: null,
  roleName: null,
  roleId: null,
  storeId: null,
  menuPermissionsList: []
})
// 合作身份编辑权限校验规则
const rolePermissionsRules = {
  roleId: [
    { required: true, message: "请选择权限角色", trigger: "change" }
  ]
}
// 关闭合作身份编辑权限
const closeRolePermissions = () => {
  openRolePermissions.value = false
  rolePermissionsForm.type = null
  rolePermissionsForm.name = null
  rolePermissionsForm.roleName = null
  rolePermissionsForm.roleId = null
  rolePermissionsForm.storeId = null
  rolePermissionsForm.menuPermissionsList = []
  cachePermission.value = new Set()
  defaultExpended.value = new Set()
}
// 提交合作身份编辑权限
const submitRolePermissions = async () => {
  try {
    rolePermissionsRef.value.validate(async (valid) => {
      if (valid) {
        rolePermissionsLoading.value = true
        let tempPermissions = Array.from(cachePermission.value)
        let param = {
          storeId: rolePermissionsForm.storeId,
          roleId: rolePermissionsForm.roleId,
          menuOrPermissionsList: tempPermissions
        }
        await updateOrganizePermissionIgnore(param)
        ElMessage.success("编辑成功")
        closeRolePermissions()
        rolePermissionsLoading.value = false
        handleSearch("init")
      } else {
        ElMessage.error("请根据提示修改表单信息")
      }
    })
  } catch (e) {
    console.log()
    rolePermissionsLoading.value = false
  }
}
// 处理打开分配权限面板
const handleSetPermissions = async (item) => {
  openRolePermissions.value = true
  console.log("item", item)
  rolePermissionsForm.type = item.type
  rolePermissionsForm.name = item.name
  rolePermissionsForm.storeId = item.storeId
  try {
    rolePermissionsLoading.value = true
    const res = await getOrganizeIgnore(rolePermissionsForm.storeId)
    rolePermissionsForm.roleName = res.roleName
    rolePermissionsForm.roleId = res.roleId
    rolePermissionsForm.menuPermissionsList = res.menuPermissionsList
    await handleRolesPoint(rolePermissionsForm.roleId)
    const {review: permissionArr, father: expended} = await handlePermissionsListReview(rolePermissionsForm.menuPermissionsList)
    cachePermission.value = new Set(permissionArr)
    defaultExpended.value = new Set(expended)
    rolePermissionsLoading.value = false
  } catch (e) {
    console.log(e)
    rolePermissionsLoading.value = false
  }
}

/*合作身份列表相关*/
// 合作身份列表
const cooperativeList = ref([])
// 合作身份列表加载状态
const cooperativeLoading = ref(false)
// 合作身份总数
const totalCooperative = ref(0)
// 合作身份列表当前页数
const pageCooperative = ref(1)
// 合作身份列表页长
const pageSizeCooperative = ref(5)
// 处理选择合作身份改变
const handleCooperativeChange = (e, roleIndex) => {
  const cooperative = cooperativeList.value.find(item => item.storeId === e)
  dialogAccountForm.adminStoreList[roleIndex].storeId = cooperative.storeId
  dialogAccountForm.adminStoreList[roleIndex].storeName = cooperative.name
  console.log("dialogAccountForm.adminStoreList", dialogAccountForm.adminStoreList)
  dialogFormAccountRef.value.validateField("adminStoreList")
}
// 处理合作身份翻页
const handleChangeCooperativePage = (e) => {
  pageCooperative.value = e
  handleGetCooperativeList()
}
// 搜索关键字缓存
const keywordCooperative = ref()
// 搜索触发函数
const handleRemoteCooperativeSearch = (keyword) => {
  keywordCooperative.value = keyword
  pageCooperative.value = 1
  handleGetCooperativeList()
}
// 获取合作身份列表
const handleGetCooperativeList = async () => {
  cooperativeLoading.value = true
  const page = {
    page: pageCooperative.value,
    pageSize: pageSizeCooperative.value,
  }
  let param = {
    keyword: keywordCooperative.value || null,
    tenantId: tenantInfo.value.tenantId,
  }
  const res = await listTenantOrganizeIgnore(page, param)
  cooperativeList.value = res.list
  totalCooperative.value = parseInt(res.total)
  console.log(res)
  cooperativeLoading.value = false
}
// 处理所属合作身份是否可选判断
const handleDisabledStoreId = (storeId) => {
  return dialogAccountForm.adminStoreList.some(role => role.storeId === storeId);
}

/*权限角色列表相关*/
// 权限角色列表
const roleList = ref([])
// 权限角色列表加载状态
const roleLoading = ref(false)
// 权限角色总数
const totalRole = ref(0)
// 权限角色列表当前页数
const pageRole = ref(1)
// 权限角色列表页长
const pageSizeRole = ref(5)
// 处理选择权限角色改变
const handleRoleChange = async (e) => {
  const role = roleList.value.find(item => item.roleId === e)
  rolePermissionsForm.roleId = role.roleId
  rolePermissionsForm.roleName = role.roleName
  rolePermissionsRef.value.validateField("adminStoreList")
  await handleRolesPoint(role.roleId)
}
// 处理权限角色翻页
const handleChangeRolePage = (e) => {
  pageRole.value = e
  handleGetRoleList()
}
// 搜索关键字缓存
const keywordRole = ref()
// 搜索触发函数
const handleRemoteRoleSearch = (keyword) => {
  keywordRole.value = keyword
  pageRole.value = 1
  handleGetRoleList()
}
// 获取权限角色列表
const handleGetRoleList = async () => {
  roleLoading.value = true
  const page = {
    page: pageRole.value,
    pageSize: pageSizeRole.value,
  }
  let param = {
    roleName: keywordRole.value || null,
    systemType: "MERCHANT"
  }
  const res = await listRole(page, param)
  roleList.value = res.list
  totalRole.value = parseInt(res.total)
  console.log(res)
  roleLoading.value = false
}

/*选择合作身份弹窗相关*/
// 弹窗状态
const openCooperative = ref(false)
// 处理下一步
const handleNextStep = () => {
  if (checkList.value.length <= 0) return ElMessage.error("请至少选择一个合作身份")
  const target = checkList.value[0]
  if (target === "A") {
    router.push({path: "/addTenantClub", query: {tenantId: tenantInfo.value.tenantId}})
  } else if (target === "B") {
    router.push({path: "/addTenantPost", query: {tenantId: tenantInfo.value.tenantId}})
  } else if (target === "C") {
    router.push({path: "/addTenantVenue", query: {tenantId: tenantInfo.value.tenantId}})
  } else if (target === "D") {
    router.push({path: "/addTenantBikeStore", query: {tenantId: tenantInfo.value.tenantId}})
  } else if (target === "E") {
    router.push({path: "/addTenantTherapy", query: {tenantId: tenantInfo.value.tenantId}})
  } else if (target === "F") {
    router.push({path: "/addTenantPhotography", query: {tenantId: tenantInfo.value.tenantId}})
  } else if (target === "G") {
    router.push({path: "/addTenantBrand", query: {tenantId: tenantInfo.value.tenantId}})
  }
}
// 已勾选的合作身份列表
const checkList = ref([])

/*合作身份列表相关*/
// 合作身份列表
const partnerList = ref([])
// 合作身份列表加载状态
const partnerLoading = ref(false)
// 查询合作身份的商家id
const cacheTenantId = ref()
// 获取合作身份列表
const handleGetPartnerList = async () => {
  partnerLoading.value = true
  let page = {
    page: 1,
    pageSize: 100,
  }
  let param = {
    tenantId: cacheTenantId.value,
    storeId: cacheStoreId.value
  }
  const res = await listTenantOrganizeNotStoreIdIgnore(page, param)
  partnerList.value = res.list
  console.log(res)
  partnerLoading.value = false
}

/*合作身份面板弹窗相关*/
// 面板锚点
const YTPartnerSelectPanelRef = ref()
// 处理面板打开
const handleOpenPanel = async () => {
  if (!cacheTenantId.value) return ElMessage.error("请先选择所属商家")
  YTPartnerSelectPanelRef.value.handleOpen()
  await handleGetPartnerList()
}
// 处理面板确认
const handlePanelConfirm = async (stores) => {
  try {
    loading.value = true
    console.log("stores", stores)
    cachePartnerStores.value = stores
    let temp = stores.map(store => (store.storeId))
    console.log("cacheStoreId.value", cacheStoreId.value)
    let param = {
      storeId: cacheStoreId.value,
      partnerStoreIds: temp
    }
    console.log("param", param)
    await uploadStoreCooperation(param)
    ElMessage.success("修改成功")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理面板关闭
const handlePanelClose = () => {
  cacheTenantId.value = null
  cachePartnerStores.value = []
  cacheStoreId.value = null
}
// 合作身份已选缓存
const cachePartnerStores = ref([])
// 店铺ID缓存
const cacheStoreId = ref()

/*合作身份权限节点相关*/
// 树形控件属性设置
const treeProps = {
  label: "value",
  children: "childrenList",
  disabled: "disabled"
}
// 菜单列表
const options = ref([])
// 勾选的菜单权限列表
const cachePermission = ref(new Set())
// 默认打开的菜单key
const defaultExpended = ref(new Set())
// 处理复选框选中节点
const handleCheck = (checkedNode, checkedObj) => {
  // 过滤非权限节点，赋值给权限数组
  console.log("checkedNode", checkedNode)
  console.log("checkedObj", checkedObj)
  let arr = [...checkedObj.checkedKeys, ...checkedObj.halfCheckedKeys]
  // 三级节点带#permission时，四级节点不可以单选，勾选一个后其余必须全选否则会出bug
  cachePermission.value = new Set(arr.filter(item => item.includes("#")))
  console.log("cachePermission", cachePermission.value)
}
// 处理根据角色获取权限节点
const handleRolesPoint = async (roleId) => {
  try {
    rolePermissionsLoading.value = true
    let param = {
      systemType: "MERCHANT",
      disableRoleId: roleId
    }
    options.value = await listMenuAll(param)
    options.value = await setDisabled(options.value)
    console.log("options", options.value)
    rolePermissionsLoading.value = false
  } catch (e) {
    console.log(e)
    rolePermissionsLoading.value = false
  }
}
// 处理子节点全部disabled: true设置父节点disabled: true
const setDisabled = (nodes) => {
  return nodes.map(node => {
    // 有子节点才处理
    if (node.childrenList && node.childrenList.length > 0) {
      node.childrenList = setDisabled(node.childrenList)

      // 判断子节点是否全部 disabled
      node.disabled = node.childrenList.every(child => child.disabled)
    }

    return node
  })
}
// 处理菜单权限反显
const handlePermissionsListReview = async (list) => {
  let review = []
  let father = []
  try {
    // 一级
    console.log("list", list)
    list.forEach((item) => {
      // 二级
      if (item.childrenList?.length > 0) {
        item.childrenList?.forEach(son => {
          // 三级
          if (son.childrenList?.length > 0) {
            son.childrenList?.forEach(grandSon => {
              // 四级
              if (grandSon.childrenList?.length > 0) {
                grandSon.childrenList?.forEach(greatGrandSon => {
                  if (greatGrandSon.childrenList?.length > 0) {
                    // 五级
                    greatGrandSon.childrenList?.forEach(greatGreatGrandSon => {
                      father.push(greatGrandSon.key)
                      review.push(greatGreatGrandSon.key)
                    })
                  } else {
                    father.push(grandSon.key)
                    review.push(greatGrandSon.key)
                  }
                })
              } else {
                father.push(son.key)
                review.push(grandSon.key)
              }
            })
          } else {
            father.push(item.key)
            review.push(son.key)
          }
        })
      } else {
        father.push(item.key)
        review.push(item.key)
      }
    })
  } catch (e) {
    console.log(e)
  }
  return {
    review,
    father
  }
}
</script>

<template>
  <el-tabs
      v-model="currentTab"
      type="card"
      class="demo-tabs"
      @tab-change="handleTabChange"
  >
    <el-tab-pane label="基本信息" name="1">
    </el-tab-pane>
    <el-tab-pane label="合作身份" name="2">
    </el-tab-pane>
    <el-tab-pane label="账号管理" name="3">
    </el-tab-pane>
  </el-tabs>
  <div v-show="currentTab === '1'" style="height: calc(100% - 55px)">
    <createTenant v-loading="loading" ref="createTenantRef" v-model="tenantInfo" :isReadMode="true" @success="handleCreateTenant"></createTenant>
  </div>
  <div v-show="currentTab === '2'" style="height: calc(100% - 55px)">
    <div class="container_box mg_b_2" style="padding-bottom: 16px">
      <div class="flex_bt" style="padding-left: 16px;">
        <div>商家名称：{{ tenantInfo.name ? tenantInfo.name : "—" }}</div>
        <v-btn color="success" @click="handleAddCooperative">
          <template v-slot:default>
            <div class="flex_bt">
              <img
                  style="width: 14px; height: 14px; margin-right: 4px"
                  src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
              />
              <span>新建合作身份</span>
            </div>
          </template>
        </v-btn>
      </div>
    </div>
    <div class="container_box">
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="tableData"
              :loading="loading"
              :items-per-page="$globalPageSize"
              :no-data-text="'没有更多数据了~'"
              hover
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
            </template>

            <template v-slot:item.type="{item}">
              <div v-if="item.type === 1">驿站</div>
              <div v-else-if="item.type === 3">俱乐部</div>
              <div v-else-if="item.type === 4">场地</div>
              <div v-else-if="item.type === 5">车店</div>
              <div v-else-if="item.type === 6">理疗服务商</div>
              <div v-else-if="item.type === 7">摄影师</div>
              <div v-else-if="item.type === 8">品牌方</div>
            </template>

            <template v-slot:item.storeAddress="{item}">
              {{item.storeAddress?.province}}{{item.storeAddress?.city}}{{item.storeAddress?.district}}
            </template>

            <template v-slot:item.crTime="{item}">
              {{item.crTime ? moment(item.crTime).format("YYYY-MM-DD") : '-'}}
            </template>

            <template v-slot:item.bikeStoreId="{item}">
              <el-text v-if="item.bikeStoreId" type="success">是</el-text>
              <span v-else>否</span>
            </template>

            <template v-slot:item.controls="{ item }">
              <div class="flex_left">
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="详情"
                    placement="left">
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-list-box-outline" color="warning" @click="handleGetDetail(item)"></v-icon>
                </el-tooltip>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="关联合作身份"
                    placement="top">
                  <v-icon class="cursor-pointer mg_r_1" v-if="item.type === 3 || item.type === 1 || item.type === 4 || item.type === 5" icon="mdi-link-variant" color="primary" size="small" @click="handleCorrelation(item)"></v-icon>
                </el-tooltip>
                <el-text style="width: 70px;" class="cursor-pointer" type="primary" @click="handleSetPermissions(item)">分配权限</el-text>
              </div>
            </template>

            <template v-slot:bottom>
              <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
  <div v-show="currentTab === '3'" style="height: calc(100% - 55px)">
    <div class="container_box mg_b_2" style="padding-bottom: 16px">
      <div class="flex_bt" style="padding-left: 16px;">
        <div>商家名称：{{ tenantInfo.name ? tenantInfo.name : "—" }}</div>
        <v-btn color="success" @click="handleAddAccount">
          <template v-slot:default>
            <div class="flex_bt">
              <img
                  style="width: 14px; height: 14px; margin-right: 4px"
                  src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
              />
              <span>新建管理账号</span>
            </div>
          </template>
        </v-btn>
      </div>
    </div>
    <div class="container_box">
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headersAccount"
              :items="tableDataAccount"
              :loading="loadingAccount"
              :items-per-page="$globalPageSize"
              :no-data-text="'没有更多数据了~'"
              hover
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
            </template>

            <template v-slot:item.adminStoreList.roleName="{item, index}">
              <div v-if="item.adminStoreList.length > 0">
                <div :class="[{mg_t_1: item.adminStoreList.length !== 1}]" v-for="(role , roleIndex) in item.adminStoreList">{{role.roleName}}</div>
              </div>
              <div v-else>
                —
              </div>
            </template>

            <template v-slot:item.adminStoreList.storeName="{item, index}">
              <div v-if="item.adminStoreList.length > 0">
                <div :class="[{mg_t_1: item.adminStoreList.length !== 1}]" v-for="(role , roleIndex) in item.adminStoreList">{{role.storeName}}</div>
              </div>
              <div v-else>
                —
              </div>
            </template>

            <template v-slot:item.bindWechat="{item}">
              <el-text type="success" v-show="item.bindWechat === '是'">{{item.bindWechat}}</el-text>
              <span v-show="item.bindWechat !== '是'" class="tips_default">未绑定</span>
            </template>

            <template v-slot:item.controls="{ item }">
              <div class="flex_left">
                <el-popconfirm @confirm="handleUnBindWeChat(item)" :title="`确定解绑 “${item.nickname}” 微信吗？`">
                  <template #reference>
                    <div>
                      <el-tooltip
                          class="box-item"
                          effect="dark"
                          content="微信解绑"
                          placement="left">
                        <v-icon class="cursor-pointer" icon="mdi-link-variant-off" color="error" v-show="item.bindWechat === '是'" size="small"></v-icon>
                      </el-tooltip>
                    </div>
                  </template>
                  <template #actions="{ confirm, cancel }">
                    <div class="flex_bt">
                      <v-btn size="small" @click="cancel">取消</v-btn>
                      <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                    </div>
                  </template>
                </el-popconfirm>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="微信绑定"
                    placement="left">
                  <v-icon icon="mdi-link-variant" color="primary" size="small" v-show="item.bindWechat !== '是'" @click="handleBindWeChat(item)"></v-icon>
                </el-tooltip>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="编辑"
                    placement="top">
                  <v-icon class="cursor-pointer mg_r_1 mg_l_1" size="small" icon="mdi-file-edit-outline" color="primary" @click="handleEditAccount(item)"></v-icon>
                </el-tooltip>
                <el-popconfirm @confirm="handleRemove(item)" :title="`确定删除 “${item.nickname}” 账号吗？`">
                  <template #reference>
                    <div>
                      <el-tooltip
                          class="box-item"
                          effect="dark"
                          content="删除"
                          placement="top"
                          @click.stop>
                        <v-icon class="cursor-pointer" color="error" icon="mdi-close"></v-icon>
                      </el-tooltip>
                    </div>
                  </template>
                  <template #actions="{ confirm, cancel }">
                    <div class="flex_bt">
                      <v-btn size="small" @click="cancel">取消</v-btn>
                      <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                    </div>
                  </template>
                </el-popconfirm>
              </div>
            </template>

            <template v-slot:bottom>
              <YTTablePagination ref="YTTablePaginationAccountRef" :total="totalAccount" @page-change="handleChangeAccountPage"></YTTablePagination>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
  <YTPartnerSelectPanel :tenantName="tenantInfo.name" :loading="partnerLoading" ref="YTPartnerSelectPanelRef" :selectedStores="cachePartnerStores" :tableData="partnerList" @confirm="handlePanelConfirm" @close="handlePanelClose"></YTPartnerSelectPanel>
  <YTFormDialog id="dialog" :isPersistent="false" :open="openQR" :title="'绑定微信二维码'" :max-width="400" style="text-align: center" @close="closeQRDialog">
    <template v-slot:content="{form}">
      <div class="tips_default" style="font-size: 14px">若需要下载二维码,请右键点击二维码选择“图片另存为...”</div>
      <div id="qrCodeDialog" class="mg_0_auto" style="height: 260px;overflow: hidden"></div>
    </template>
    <template v-slot:actions="{form}">
      <v-row>
        <v-col cols="12">
          <div class="flex_center">
            <v-btn class="mg_l_1" variant="elevated" @click="closeQrCodeDialog">返回</v-btn>
          </div>
        </v-col>
      </v-row>
    </template>
  </YTFormDialog>
  <el-dialog
      v-model="openAccount"
      width="650"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">{{accountIsEdit ? "编辑" : "新建"}}管理账号</div>
    </template>
    <el-form
        ref="dialogFormAccountRef"
        style="max-width: 100%;"
        :model="dialogAccountForm"
        :rules="dialogAccountRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="dialogAccountLoading"
        id="dialogForm"
    >
      <el-form-item label="用户名：" prop="nickname">
        <el-input v-model="dialogAccountForm.nickname" placeholder="请输入用户名" />
      </el-form-item>
      <el-form-item label="账号：" prop="username">
        <el-input v-model="dialogAccountForm.username" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="所属商家：" prop="tenantId">
        {{ tenantInfo.name ? tenantInfo.name : "—" }}
      </el-form-item>
      <el-form-item label="合作身份：" prop="adminStoreList">
        <div>
          <div class="mg_b_1" v-for="(role, roleIndex) in dialogAccountForm.adminStoreList">
            <!--选了身份就必填权限角色，一种合作身份只能选一次-->
            <div class="flex_left flex_1 mg_b_1 w-100">
              <el-select
                  v-model="role.storeId"
                  placeholder="所属合作身份"
                  style="width: 150px;"
                  :loading="cooperativeLoading"
                  @change="(e) => handleCooperativeChange(e, roleIndex)"
                  filterable
                  remote
                  remote-show-suffix
                  :remote-method="handleRemoteCooperativeSearch"
                  class="mg_r_1"
              >
                <el-option
                    v-for="item in cooperativeList"
                    :key="`cooperativeId${item.storeId}`"
                    :label="item.name"
                    :value="item.storeId"
                    :disabled="handleDisabledStoreId(item.storeId)"
                />
                <template v-if="!loading && !cooperativeList.some(res => res.storeId === role.storeId) && role.storeId" #header>
                  当前已选：
                  <el-option
                      :label="role.storeName"
                      :value="role.storeId"
                  />
                </template>

                <template #footer>
                  <div class="flex_center">
                    <el-pagination
                        size="small"
                        background
                        layout="prev, pager, next"
                        :total="totalCooperative"
                        class="mt-4"
                        v-model:current-page="pageCooperative"
                        v-model:page-size="pageSizeCooperative"
                        @current-change="handleChangeCooperativePage"
                    />
                  </div>
                </template>
              </el-select>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="删除"
                  placement="right"
                  @click.stop>
                <v-icon class="cursor-pointer mg_l_1" v-if="dialogAccountForm.adminStoreList.length > 1" color="error" icon="mdi-close" @click="handleRemoveCooperative(roleIndex)"></v-icon>
              </el-tooltip>
            </div>
          </div>
          <div class="flex_left">
            <div class="cursor-pointer" style="display: inline-flex;align-items: center" @click="addCooperative">
              <v-icon class="mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32"></v-icon>
              <div>添加合作身份</div>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="closeAccountDialog">取消</v-btn>
              <v-btn class="mg_l_1" :disabled="dialogAccountLoading" color="primary" variant="elevated" @click="submitAccountDialog">提交</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
  <el-dialog
      v-model="openCooperative"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">新建合作身份</div>
    </template>
    <div>
      <div class="mg_b_2" style="text-align: left;box-sizing: border-box;padding-left: 48px;">
        请选择合作身份类型：
      </div>
      <div style="box-sizing: border-box;padding-left: 48px;">
        <el-checkbox-group v-model="checkList" :max="1">
          <el-checkbox style="display: block;flex: 1;text-align: left" label="俱乐部" value="A" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="驿站" value="B" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="场地" value="C" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="车店" value="D" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="理疗服务商" value="E" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="摄影服务商" value="F" />
          <el-checkbox style="display: block;flex: 1;text-align: left" label="品牌方" value="G" />
        </el-checkbox-group>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn @click="openCooperative = false">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="handleNextStep">下一步</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
  <el-dialog
      v-model="openRolePermissions"
      width="650"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">编辑权限</div>
    </template>
    <el-form
        ref="rolePermissionsRef"
        style="max-width: 100%;"
        :model="rolePermissionsForm"
        :rules="rolePermissionsRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="rolePermissionsLoading"
        id="rolePermissionsForm"
    >
      <el-form-item label="所属商家：">
        {{ tenantInfo.name ? tenantInfo.name : "—" }}
      </el-form-item>
      <el-form-item label="合作身份：">
        {{rolePermissionsForm.name}}（
        <div v-if="rolePermissionsForm.type === 1">驿站</div>
        <div v-else-if="rolePermissionsForm.type === 3">俱乐部</div>
        <div v-else-if="rolePermissionsForm.type === 4">场地</div>
        <div v-else-if="rolePermissionsForm.type === 5">车店</div>
        <div v-else-if="rolePermissionsForm.type === 6">理疗服务商</div>
        <div v-else-if="rolePermissionsForm.type === 7">摄影师</div>
        <div v-else-if="rolePermissionsForm.type === 8">品牌方</div>
        ）
      </el-form-item>
      <el-form-item label="权限角色：" prop="roleId">
        <el-select
            v-model="rolePermissionsForm.roleId"
            placeholder="权限角色"
            style="width: 150px;"
            :loading="roleLoading"
            @change="(e) => handleRoleChange(e)"
            filterable
            remote
            remote-show-suffix
            :remote-method="handleRemoteRoleSearch"
            class="mg_r_1"
        >
          <el-option
              v-for="item in roleList"
              :key="`roleList${item.roleId}`"
              :label="item.roleName"
              :value="item.roleId"
          />
          <template v-if="!loading && !roleList.some(res => res.roleId === rolePermissionsForm.roleId) && rolePermissionsForm.roleId" #header>
            当前已选：
            <el-option
                :label="rolePermissionsForm.roleName"
                :value="rolePermissionsForm.roleId"
            />
          </template>

          <template #footer>
            <div class="flex_center">
              <el-pagination
                  size="small"
                  background
                  layout="prev, pager, next"
                  :total="totalRole"
                  class="mt-4"
                  v-model:current-page="pageRole"
                  v-model:page-size="pageSizeRole"
                  @current-change="handleChangeRolePage"
              />
            </div>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="追加权限：">
        <transition name="el-zoom-in-top">
          <div class="role_point_box" style="flex: 1" v-show="rolePermissionsForm.roleId !== null">
            <el-tree
                ref="treeRef"
                style="max-width: 800px"
                :props="treeProps"
                show-checkbox
                :data="options"
                @check="(checkedNode, checkedObj) => handleCheck(checkedNode, checkedObj)"
                node-key="key"
                :default-expanded-keys="Array.from(defaultExpended)"
                :default-checked-keys="Array.from(cachePermission)"
            />
          </div>
        </transition>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="closeRolePermissions">取消</v-btn>
              <v-btn class="mg_l_1" :disabled="rolePermissionsLoading" color="primary" variant="elevated" @click="submitRolePermissions">提交</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.role_point_box {
  width: 100%;
  min-height: 200px;
  border-radius: 10px;
  box-sizing: border-box;
  border: 1px solid #222222;
  padding: 10px;
  overflow: auto;
}
</style>
